import * as Yup from 'yup';

export const mapFormModel = {
  formId: 'mapConfig',
  formField: {
    fromAddress: {
      name: 'from_dispenser_address',
      label: 'From Dispenser Address',
      requiredErrorMsg: 'From Dispenser Address is required',
      type: 'text'
    },
    toAddress: {
      name: 'to_dispenser_address',
      label: 'To Dispenser Address',
      requiredErrorMsg: 'To Dispenser Address is required',
      type: 'text'
    }
  }
};

const {
  formField: {
    fromAddress,
    toAddress
  }
} = mapFormModel;

export const mapFormInitialValues = {
  [fromAddress.name]: '',
  [toAddress.name]: ''
};

export const mapValidationSchema = Yup.object().shape({
  [fromAddress.name]: Yup.string()
    .required(fromAddress.requiredErrorMsg)
    .matches(/^\d{4}$/, 'Must be exactly 4 digits'),

  [toAddress.name]: Yup.string()
    .required(toAddress.requiredErrorMsg)
    .matches(/^\d{4}$/, 'Must be exactly 4 digits')
});
